import api from './axiosConfig.js'

export const deviceApi = {
  // Device management
  listDevices: (params = {}, config = {}) =>
    api.get('/devices/get-all-devices', { params, ...config }),

  registerDevice: (deviceData, config = {}) =>
    api.post('/devices/register-device', deviceData, config),

  getDevice: (id, config = {}) =>
    api.get('/devices/get-device', { params: { id }, ...config }),

  updateDevice: (id, deviceData, config = {}) =>
    api.put('/devices/update-device', deviceData, { params: { id }, ...config }),

  deleteDevice: (id, config = {}) =>
    api.delete('/devices/delete-device', { params: { id }, ...config }),

  // Device authentication
  deviceLogin: (credentials, config = {}) =>
    api.post('/devices/auth', credentials, config),
}